<template>
  <div>
    <Banner :imageList="this.config.banner_top.imageList"></Banner>
    <Number></Number>
    <Brand></Brand>
    <News></News>

    <Service></Service>
    <Cloud></Cloud>
    <!-- <Banner2></Banner2> -->
    <Business></Business>
    <Banner3></Banner3>
  </div>
</template>

<script>
import Banner from "@/yintai/view/content/homepage/Banner.vue";
import Number from "@/yintai/view/content/homepage/Number.vue";
import Brand from "@/yintai/view/content/homepage/Brand.vue";
import News from "@/yintai/view/content/homepage/News.vue";

import Cloud from "@/yintai/view/content/homepage/Cloud.vue";
import Service from "@/yintai/view/content/homepage/Service.vue";
// import Banner2 from "@/yintai/view/content/homepage/Banner2.vue";
import Business from "@/yintai/view/content/homepage/Business.vue";
import Banner3 from "@/yintai/view/content/homepage/Banner3.vue";
import { fetchConfig } from "@/yintai/api/config";

export default {
  name: "home",
  components: {
    Banner,
    Number,
    Brand,
    News,
    Cloud,
    Service,
    // Banner2,
    Business,
    Banner3,
  },
  metaInfo() {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      meta: [{name: "keywords" ,content:"银泰百货,银泰商业,新零售商场,智慧新零售,银泰商业文化"},{name: "description" ,content:"银泰百货是以百货零售业为主营业务的百货零售集团。银泰商业结合银泰百货的优势实现管理创新、业态创新，实施品牌战略，形成具备银泰商业文化特色的大型新零售企业品牌。"}],
      title: "银泰商业__线上线下高度融合的数字商场_银泰百货官网"
      // all titles will be injected into this template
      // titleTemplate: "%s | My Awesome Webapp",
    };
  },
  data() {
    return {
      config: {
        banner_top: {},
      },
    };
  },
  async mounted() {
    const response = await fetchConfig({ id: 1 });
    this.config = response.data.data.item.config;
  },
  methods: {},
};
</script>
